import { useState } from 'react';

/**
 * Used to create an instance of MenuReferenceProps
 */
export const useMenu = () => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState();
  const close = () => {
    setOpen(false);
  };
  const onClick = e => {
    setOpen(prev => !prev);
    setAnchorEl(e.currentTarget);
  };
  return {
    referenceProps: {
      anchorEl,
      onClose: close,
      open
    },
    onClick,
    setOpen,
    setAnchorEl
  };
};